module.exports = __webpack_public_path__ + "static/media/image-model.8b6e1aea.jpg";